import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';

const ProtectedRoute = () => {
  const isLoggedIn = useSelector((state) => state.auth.login);
  return isLoggedIn ? <Outlet /> : <Navigate to="/" />;
};

ProtectedRoute.propTypes = {};

export default ProtectedRoute;
